import { useEffect, useState } from 'react';
import * as ImportTypes from 'documents-ui/constants/ImportTypes';
// @ts-expect-error File is untyped
import addScript from 'documents-ui/lib/addScript';
import ButtonWithEditWarning from './ButtonWithEditWarning';
import { BoxIcon } from 'foundations-assets/icons/components/BoxIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const isLoaded = () => {
  // @ts-expect-error BoxSelect is not defined
  return window.BoxSelect === undefined;
};
const BoxButton = ({
  useMultiSelect,
  importFile,
  editWarningConfig,
  onClick
}) => {
  const [loaded, setLoaded] = useState(isLoaded());
  useEffect(() => {
    addScript('https://app.box.com/js/static/select.js').then(() => {
      setLoaded(isLoaded());
    }).catch(error => {
      console.error(error);
    });
  });
  const handleSuccess = files => {
    files.forEach(({
      name,
      url
    }) => importFile({
      type: ImportTypes.BOX,
      file: {
        name,
        link: url
      }
    }));
  };
  const handleClick = () => {
    // @ts-expect-error BoxSelect is not defined
    const {
      BoxSelect
    } = window;
    const boxSelect = BoxSelect({
      scriptSource: 'https://app.box.com/js/static/select.js',
      clientId: 'g8jf67q0iob45iv2v0oq5sov3zxvsbub',
      linkType: 'direct',
      multiSelect: useMultiSelect
    });
    boxSelect.success(handleSuccess);
    boxSelect.launchPopup();
    onClick();
  };
  return /*#__PURE__*/_jsx(ButtonWithEditWarning, Object.assign({}, editWarningConfig, {
    onClick: handleClick,
    disabled: loaded,
    icon: BoxIcon,
    children: "Box"
  }));
};
export default BoxButton;